import { render } from "./WorkshopPaymentSuccess.vue?vue&type=template&id=52fa34da&scoped=true"
import script from "./WorkshopPaymentSuccess.vue?vue&type=script&lang=js"
export * from "./WorkshopPaymentSuccess.vue?vue&type=script&lang=js"

import "./WorkshopPaymentSuccess.vue?vue&type=style&index=0&id=52fa34da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fa34da"]])

export default __exports__